// extracted by mini-css-extract-plugin
export default {"content":"content_content__bq2tU","inProject":"content_inProject__ePoJh"};